import { render, staticRenderFns } from "./CompetitionsCreate.vue?vue&type=template&id=5ef6c273&"
import script from "./CompetitionsCreate.vue?vue&type=script&lang=js&"
export * from "./CompetitionsCreate.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports